<template>
    <nav>
        <v-toolbar elevation="0"  style="height:67px; background: linear-gradient(#0a42da,#0a42da,white);">
            <v-app-bar-nav-icon style="color:white"  @click="drawer=!drawer" v-if="isLoginPage()"></v-app-bar-nav-icon>
            <v-toolbar-title >
                <span style="color:white">Gestion de patients</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu v-if="isLoginPage()">
      <template v-slot:activator="{ props: menu }">
        <v-tooltip location="top">
          <template v-slot:activator="{ props: tooltip }">
            <v-btn
            color="white" 
              v-bind="mergeProps(menu, tooltip)"
            >
            <v-icon icon="mdi-account" color="white" ></v-icon>
            {{ name }}
            </v-btn>
          </template>
      
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
        
        >
          <v-list-item-title>   <v-btn  
              @click="logout()" v-if="isLoginPage()">
              <v-icon icon="mdi-logout" color="red"></v-icon>
                 Se déconnecter
                
            </v-btn></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
   
        </v-toolbar>
        <v-navigation-drawer  temporary v-model="drawer" style="border-end-end-radius: 10%;border-top-right-radius: 10%;background: linear-gradient(#0a42da,#0a42da,#63e3ef,white);"  color="#0f58b7"
        
        >
     
            <v-list>
                <v-list-group  >
                    <template v-slot:activator="{ props }">
                <v-list-item
                v-bind="props"
                title="Patient"
                ></v-list-item>
             </template>
             <v-list-item            
                title="Création"
                route to="/NouveauPatient"
            ></v-list-item>
            <v-list-item            
                title="Transmission"
                route to="/patient"
            ></v-list-item>
            </v-list-group>
                <v-list-group  v-if="show()">
                    <template v-slot:activator="{ props }">
                <v-list-item
                v-bind="props"
                title="Document"
                ></v-list-item>
             </template>
             <v-list-item            
                title="document à envoyer"
                route to="/Transmission"
            ></v-list-item>
            <v-list-item            
                title="document envoyés"
                route to="/ListTransmission"
            ></v-list-item>
            </v-list-group>
            <!-- <v-list-group  >
                    <template v-slot:activator="{ props }">
                <v-list-item
                v-bind="props"
                title="Médecin"
                ></v-list-item>
             </template>
             <v-list-item            
                title="Création"
                route to="/NouveauMedecin"
            ></v-list-item>
            <v-list-item            
                title="Liste"
                route to="/ListMedecin"
            ></v-list-item>
            </v-list-group> -->
            <v-list-group value="Admin"  v-if="show()">
            <template v-slot:activator="{ props }">
                <v-list-item
                v-bind="props"
                title="Admin"
                ></v-list-item>
            </template>

          <v-list-item            
            key="1"
            value="utilisateur"
            title="Utilisateur"
            route to="/user/listuser"
          ></v-list-item>
        </v-list-group>
        </v-list>
        </v-navigation-drawer>

    </nav>
</template>
<script>
//import {useAuthStore} from './../store/store.js'
import { mergeProps } from 'vue'
export default {
    data(){
        return {
            drawer:false,
            name:null
        }
    },
    methods:{
        mergeProps,
        nameLogin(){
            return localStorage.getItem("user");
        },
        isLoginPage(){
          let  use= JSON.parse(localStorage.getItem("user"));
          
            this.name= use?.fullname;
              return this.$route.name!='UserLogin'
        },
        logout() {
            this.user = null;
            localStorage.removeItem('user');
           // window.location.href ='user/UserLogin'
           this.$router.push('/login'); //TODO
        },
        show(){
           const  user =JSON.parse(localStorage.getItem("user"));
           return user?.profil == "admin";
        }
        
    }

 



}
</script>